import React from 'react';

// Shared assets
import imgImage5 from '../../assets/sections/1dd5948ad63fcd55ae93c709623f0b974fc45564.png';
import imgIconPin from '../../assets/sections/4c7642f5666923d0d8301ca0b0003a2156829edc.svg';
import imgIconPinMobile from '../../assets/sections/a2da9aa45c7bbb15ef090f5c242ca91de83b6739.svg';
import imgVectorDot from '../../assets/sections/9afabce01139b40c724759b2766247952b2f32b8.svg';
import imgVectorDot2 from '../../assets/sections/89869a35da087b8690636d97b32ac04d11727c89.svg';

// Desktop logos
import imgLogoTopCV from '../../assets/sections/58b993bd5d972cb3e91e6c24ed89e77e1bfa1894.svg';
import imgGroupTopCV from '../../assets/sections/f676bd36f885a788bc79f1737f42be5dfce83807.svg';
import imgLogoTopCVPro from '../../assets/sections/754bacb22a0fc4df7f7b19b08a1204164c6bc8e6.svg';
import imgVectorHappyTime from '../../assets/sections/dc5c4c4fac6c702affb82eaa187307a290cd6aaa.svg';
import imgVectorSHiring from '../../assets/sections/822671b10c0b069f994fe7f0109ab602587852de.svg';
import imgLogoTestCenterVn from '../../assets/sections/b10f848e39113d08f5f33560e3a1df750062a383.svg';
import imgLogoTestCenter from '../../assets/sections/8e67c7940c71d5ecbb55cd49b16ac20f0e89f912.svg';
import imgLine from '../../assets/sections/65f6d2d51aa78130db14a717467062e5bba38e4d.svg';

// Mobile logos
import imgLogoTopCVMobile from '../../assets/sections/095950c54e0e0afaabaedc26b44ee1b6ecffa557.svg';
import imgLogoTopCVProMobile from '../../assets/sections/365c4b9f238944c62c2cc2cc7b1b24ef55b84a90.svg';
import imgLineMobile from '../../assets/sections/5d8c0637bf01fa95bf1c56667ec6dec3a9b9a0b0.svg';


// ──────────────────────────────────────────────
// QR badge (shared between desktop & mobile)
// ──────────────────────────────────────────────
function QrBadge({ size = 85 }) {
  // The QR badge is the inline-grid "dots" watermark + image5 + topcv.vn label
  // Desktop uses the complex inline-grid from the Figma output.
  // We simplify to just show image5 (which already contains the QR visual) + label.
  return (
    <div className="flex flex-col gap-[4px] items-center shrink-0" data-node-id="2011:949">
      <div className="relative" style={{ width: size, height: size }}>
        <img alt="TopCV QR" className="absolute inset-0 max-w-none object-cover w-full h-full" src={imgImage5} />
        {/* Dot overlay exactly from Figma */}
        {[
          [14.51,52.89],[17.28,52.89],[22.79,52.89],[31.07,52.89],[39.34,52.89],
          [53.13,52.89],[64.17,52.89],[69.68,52.89],[77.96,52.89],[80.71,52.89],
        ].map(([ml,mt], i) => (
          <div key={i} className="absolute" style={{ left: ml, top: mt, width: 2.764, height: 2.764 }}>
            <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorDot} />
          </div>
        ))}
        <div className="absolute" style={{ left: 86.24, top: 52.89, width: 2.764, height: 2.764 }}>
          <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorDot2} />
        </div>
      </div>
      <p className="font-['Alexandria',sans-serif] font-light leading-[1.5] text-[12px] text-[#00b14f] text-center whitespace-nowrap" data-node-id="2011:964">
        topcv.vn
      </p>
    </div>
  );
}


// ──────────────────────────────────────────────
// Desktop Footer (≥ 840px viewport)
// ──────────────────────────────────────────────
function FooterDesktop() {
  return (
    <div
      className="bg-white flex flex-col gap-[8px] items-center pb-[10px] pt-[40px] w-full"
      data-node-id="2011:921"
    >
      {/* Company info row */}
      <div className="flex gap-[24px] items-start w-[840px]" data-node-id="2011:922">
        {/* Text info */}
        <div className="flex flex-[1_0_0] flex-col gap-[16px] items-start min-w-0" data-node-id="2011:923">
          <p className="font-['Alexandria',sans-serif] font-medium leading-[1.5] text-[16px] text-[#212f3f] w-full" data-node-id="2011:924">
            Công ty Cổ phần TopCV Việt Nam
          </p>
          <div className="flex flex-col gap-[8px] items-start w-full" data-node-id="2011:925">
            {/* HN address */}
            <div className="flex gap-[8px] items-center py-px w-full" data-node-id="2011:941">
              <div className="relative shrink-0 w-[12px] h-[12px]" data-node-id="2011:942">
                <div className="absolute" style={{ inset: '-1.2% 0 0 0' }}>
                  <img alt="" className="block max-w-none w-full h-full" src={imgIconPin} />
                </div>
              </div>
              <p className="font-['Alexandria',sans-serif] font-light leading-[1.5] text-[12px] text-[#212f3f] whitespace-nowrap" data-node-id="2011:944">
                Trụ sở HN: Tầng 3, NO1-HH1, số 47 Nguyễn Tuân, Phường Thanh Xuân, Thành phố Hà Nội, Việt Nam
              </p>
            </div>
            {/* HCM address */}
            <div className="flex gap-[8px] items-center w-full" data-node-id="2011:945">
              <div className="relative shrink-0 w-[12px] h-[12px]" data-node-id="2011:946">
                <div className="absolute" style={{ inset: '-1.2% 0 0 0' }}>
                  <img alt="" className="block max-w-none w-full h-full" src={imgIconPin} />
                </div>
              </div>
              <p className="font-['Alexandria',sans-serif] font-light leading-[1.5] text-[12px] text-[#212f3f] whitespace-nowrap" data-node-id="2011:948">
                Trụ sở TP HCM: Tầng 12, toà nhà Dali, số 24C Phan Đăng Lưu, Phường Gia Định, Thành phố Hồ Chí Minh, Việt Nam
              </p>
            </div>
          </div>
        </div>
        {/* QR badge */}
        <QrBadge size={85} />
      </div>

      {/* Ecosystem + copyright */}
      <div className="flex flex-col gap-[28px] items-center w-[840px]" data-node-id="2011:965">
        <div className="flex flex-col gap-[8px] items-center w-full" data-node-id="2011:966">
          <p className="font-['Alexandria',sans-serif] font-medium leading-[1.5] text-[12px] text-[#212f3f] tracking-[0.24px] w-full" data-node-id="2011:967">
            Hệ sinh thái HR Tech của TopCV
          </p>
          {/* 5 ecosystem cards */}
          <div className="flex items-center justify-between w-[840px]" data-node-id="2011:968">
            {/* TopCV */}
            <div className="flex flex-col h-[80px] items-start overflow-clip px-[16px] rounded-[8px] w-[160px]"
              data-node-id="2011:969"
              style={{ backgroundImage: 'linear-gradient(116.565deg, #212f3f 0%, #00b14f 100%)' }}>
              <div className="h-[40px] relative w-full" data-node-id="2011:970">
                <div className="absolute overflow-clip h-[30px] w-[64.688px]" style={{ top: '50%', left: '-10px', transform: 'translateY(-50%)' }}>
                  <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTopCV} />
                  <div className="absolute" style={{ inset: '24.39% 10.99% 8.09% 15.44%' }}>
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgGroupTopCV} />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center w-full" data-node-id="2011:972">
                <p className="flex-1 font-['Alexandria',sans-serif] font-medium leading-normal text-[8px] text-white min-w-0" data-node-id="2011:973">
                  Nền tảng công nghệ<br />tuyển dụng thông minh<br />TopCV.vn
                </p>
              </div>
            </div>
            {/* TopCV PRO */}
            <div className="flex flex-col h-[80px] items-start overflow-clip px-[16px] rounded-[8px] w-[160px]"
              data-node-id="2011:974"
              style={{ backgroundImage: 'linear-gradient(116.565deg, #0d0b00 0%, #716120 100%)' }}>
              <div className="h-[40px] relative w-full" data-node-id="2011:975">
                <div className="absolute overflow-clip h-[30px] w-[95.862px]" style={{ top: '50%', left: '-10px', transform: 'translateY(-50%)' }}>
                  <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTopCVPro} />
                </div>
              </div>
              <div className="flex items-center justify-center w-full" data-node-id="2011:977">
                <p className="flex-1 font-['Alexandria',sans-serif] font-medium leading-normal text-[8px] text-white min-w-0" data-node-id="2011:978">
                  Không gian tuyển dụng<br />chuyên biệt cho Doanh nghiệp hàng đầu và Ứng viên chất
                </p>
              </div>
            </div>
            {/* HappyTime */}
            <div className="flex flex-col h-[80px] items-start overflow-clip px-[16px] rounded-[8px] w-[160px]"
              data-node-id="2011:979"
              style={{ backgroundImage: 'linear-gradient(116.565deg, #ff7700 0%, #f8a020 100%)' }}>
              <div className="h-[40px] relative w-full" data-node-id="2011:980">
                <div className="absolute overflow-clip size-[24px]" style={{ top: 'calc(50% + 1px)', left: 0, transform: 'translateY(-50%)' }}>
                  <div className="absolute bg-white inset-0 rounded-[6px]" />
                  <div className="absolute inset-[15%]">
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorHappyTime} />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center w-full" data-node-id="2011:982">
                <p className="flex-1 font-['Alexandria',sans-serif] font-medium leading-normal text-[8px] text-white min-w-0" data-node-id="2011:983">
                  {`Nền tảng quản lý & gia tăng`}<br />trải nghiệm nhân viên<br />HappyTime.vn
                </p>
              </div>
            </div>
            {/* SHiring */}
            <div className="flex flex-col h-[80px] items-start overflow-clip px-[16px] rounded-[8px] w-[160px]"
              data-node-id="2011:984"
              style={{ backgroundImage: 'linear-gradient(116.565deg, #00b14f 0%, #23e16e 100%)' }}>
              <div className="h-[40px] relative w-full" data-node-id="2011:985">
                <div className="absolute overflow-clip size-[24px]" style={{ top: 'calc(50% + 1px)', left: 0, transform: 'translateY(-50%)' }}>
                  <div className="absolute bg-white inset-0 rounded-[6px]" />
                  <div className="absolute" style={{ inset: '12.22% 0 12.22%', left: '50%', transform: 'translateX(-50%)', aspectRatio: '120/136' }}>
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorSHiring} />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center w-full" data-node-id="2011:987">
                <p className="flex-1 font-['Alexandria',sans-serif] font-medium leading-normal text-[8px] text-white min-w-0" data-node-id="2011:988">
                  Giải pháp quản trị<br />tuyển dụng hiệu suất cao<br />SHiring.ai
                </p>
              </div>
            </div>
            {/* TestCenter */}
            <div className="flex flex-col h-[80px] items-start overflow-clip px-[16px] rounded-[8px] w-[160px]"
              data-node-id="2011:989"
              style={{ backgroundImage: 'linear-gradient(116.565deg, #0e347f 0%, #2c4a9f 100%)' }}>
              <div className="h-[40px] relative w-full" data-node-id="2011:990">
                <div className="absolute overflow-clip h-[27px] w-[24.3px]" style={{ top: 'calc(50% + 0.5px)', left: 0, transform: 'translateY(-50%)' }}>
                  <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTestCenterVn} />
                  <div className="absolute" style={{ bottom: '27%', top: '27%', left: '50%', transform: 'translateX(-50%)', aspectRatio: '108.756/92.747' }}>
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTestCenter} />
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center w-full" data-node-id="2011:992">
                <p className="flex-1 font-['Alexandria',sans-serif] font-medium leading-normal text-[8px] text-white min-w-0" data-node-id="2011:993">
                  {`Nền tảng thiết lập & đánh giá`}<br />năng lực nhân viên<br />TestCenter.vn
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider + copyright */}
        <div className="flex flex-col gap-[8px] items-center w-full" data-node-id="2011:994">
          <div className="h-0 relative w-full" data-node-id="2011:995">
            <div className="absolute" style={{ inset: '-1px 0 0 0' }}>
              <img alt="" className="block max-w-none w-full h-full" src={imgLine} />
            </div>
          </div>
          <p className="font-['Alexandria',sans-serif] font-light leading-[1.5] text-[12px] text-[#4d5965] text-center w-full" data-node-id="2011:996">
            © 2014-2025 TopCV Vietnam JSC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}


// ──────────────────────────────────────────────
// Mobile Footer (< 840px viewport)
// ──────────────────────────────────────────────
function FooterMobile() {
  return (
    <div
      className="bg-white flex flex-col gap-[16px] items-center pb-[10px] pt-[20px] px-[25px] w-full"
      data-node-id="2011:997"
    >
      {/* Top block: company info + QR */}
      <div className="flex flex-col gap-[16px] items-center w-full" data-node-id="2011:998">
        <div className="flex flex-col gap-[16px] items-start w-full" data-node-id="2011:999">
          <p className="font-['Alexandria',sans-serif] font-medium leading-[1.5] text-[16px] text-[#212f3f] w-full" data-node-id="2011:1000">
            Công ty Cổ phần TopCV Việt Nam
          </p>
          <div className="flex flex-col gap-[8px] items-start w-full" data-node-id="2011:1001">
            {/* HN address */}
            <div className="flex gap-[8px] items-start py-px w-full" data-node-id="2011:1016">
              <div className="h-[18px] relative shrink-0 w-[12px]" data-node-id="2011:1017">
                <img alt="" className="absolute block max-w-none w-full h-full" src={imgIconPinMobile} />
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-light leading-[1.5] min-w-0 text-[12px] text-[#212f3f]" data-node-id="2011:1019">
                Trụ sở HN: Tòa FS - GoldSeason số 47 Nguyễn Tuân, P.Thanh Xuân Trung, Q.Thanh Xuân, Hà Nội
              </p>
            </div>
            {/* HCM address */}
            <div className="flex gap-[8px] items-start w-full" data-node-id="2011:1020">
              <div className="h-[18px] relative shrink-0 w-[12px]" data-node-id="2011:1021">
                <img alt="" className="absolute block max-w-none w-full h-full" src={imgIconPinMobile} />
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-light leading-[1.5] min-w-0 text-[12px] text-[#212f3f]" data-node-id="2011:1023">
                Trụ sở TP HCM: Tòa nhà Dali, 24C Phan Đăng Lưu, P.6, Q.Bình Thạnh, TP HCM
              </p>
            </div>
          </div>
        </div>
        {/* QR badge (mobile uses same image5) */}
        <QrBadge size={85} />
      </div>

      {/* Ecosystem + copyright */}
      <div className="flex flex-col gap-[16px] items-center w-full" data-node-id="2011:1511">
        <div className="flex flex-col gap-[8px] items-center w-full" data-node-id="2011:1512">
          <p className="font-['Alexandria',sans-serif] font-medium leading-[1.5] text-[12px] text-[#212f3f] text-center tracking-[0.24px] w-full" data-node-id="2011:1513">
            Hệ sinh thái HR Tech của TopCV
          </p>
          {/* Wrap cards (2 per row on mobile) */}
          <div className="flex flex-wrap gap-[4px] items-start w-full" data-node-id="2011:1514">
            {/* TopCV */}
            <div className="flex gap-[4px] items-center justify-center px-[4px] py-[8px] rounded-[8px] w-[calc(50%-2px)]"
              data-node-id="2011:1515"
              style={{ backgroundImage: 'linear-gradient(131.186deg, #212f3f 0%, #00b14f 100%)' }}>
              <div className="h-[32px] relative w-[48px] shrink-0" data-node-id="2011:1516">
                <div className="absolute overflow-clip h-[20px] w-[43.126px]" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
                  <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTopCVMobile} />
                </div>
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-normal leading-normal min-w-0 text-[7px] text-white" data-node-id="2011:1518">
                Nền tảng công nghệ tuyển dụng thông minh TopCV.vn
              </p>
            </div>
            {/* TopCV PRO */}
            <div className="flex gap-[4px] items-center justify-center px-[4px] py-[8px] rounded-[8px] w-[calc(50%-2px)]"
              data-node-id="2011:1519"
              style={{ backgroundImage: 'linear-gradient(131.186deg, #0d0b00 0%, #716120 100%)' }}>
              <div className="h-[32px] relative w-[48px] shrink-0" data-node-id="2011:1520">
                <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTopCVProMobile} />
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-normal leading-normal min-w-0 text-[7px] text-white" data-node-id="2011:1522">
                Không gian tuyển dụng chuyên biệt cho Doanh nghiệp hàng đầu và Ứng viên chất
              </p>
            </div>
            {/* HappyTime */}
            <div className="flex gap-[4px] items-center justify-center px-[4px] py-[8px] rounded-[8px] w-[calc(50%-2px)]"
              data-node-id="2011:1523"
              style={{ backgroundImage: 'linear-gradient(131.186deg, #ff7700 0%, #f8a020 100%)' }}>
              <div className="h-[32px] relative w-[48px] shrink-0" data-node-id="2011:1524">
                <div className="absolute overflow-clip size-[24px]" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
                  <div className="absolute bg-white inset-0 rounded-[6px]" />
                  <div className="absolute inset-[15%]">
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorHappyTime} />
                  </div>
                </div>
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-normal leading-normal min-w-0 text-[7px] text-white" data-node-id="2011:1526">
                {`Nền tảng quản lý & gia tăng trải nghiệm nhân viên HappyTime.vn`}
              </p>
            </div>
            {/* SHiring */}
            <div className="flex gap-[4px] items-center justify-center px-[4px] py-[8px] rounded-[8px] w-[calc(50%-2px)]"
              data-node-id="2011:1527"
              style={{ backgroundImage: 'linear-gradient(131.186deg, #00b14f 0%, #23e16e 100%)' }}>
              <div className="h-[32px] relative w-[48px] shrink-0" data-node-id="2011:1528">
                <div className="absolute overflow-clip size-[24px]" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
                  <div className="absolute bg-white inset-0 rounded-[6px]" style={{ aspectRatio: '1' }} />
                  <div className="absolute" style={{ inset: '12.22% 0', left: '50%', transform: 'translateX(-50%)', aspectRatio: '120/136' }}>
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgVectorSHiring} />
                  </div>
                </div>
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-normal leading-normal min-w-0 text-[7px] text-white" data-node-id="2011:1530">
                Giải pháp quản trị tuyển dụng hiệu suất cao SHiring.ai
              </p>
            </div>
            {/* TestCenter */}
            <div className="flex gap-[4px] items-center justify-center px-[4px] py-[8px] rounded-[8px] w-[calc(50%-2px)]"
              data-node-id="2011:1531"
              style={{ backgroundImage: 'linear-gradient(131.186deg, #0e347f 0%, #2c4a9f 100%)' }}>
              <div className="h-[32px] relative w-[48px] shrink-0" data-node-id="2011:1532">
                <div className="absolute overflow-clip h-[27px] w-[24.3px]" style={{ top: 'calc(50% + 0.5px)', left: '50%', transform: 'translate(-50%,-50%)' }}>
                  <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTestCenterVn} />
                  <div className="absolute" style={{ bottom: '27%', top: '27%', left: '50%', transform: 'translateX(-50%)', aspectRatio: '108.756/92.747' }}>
                    <img alt="" className="absolute block max-w-none w-full h-full" src={imgLogoTestCenter} />
                  </div>
                </div>
              </div>
              <p className="flex-1 font-['Alexandria',sans-serif] font-normal leading-normal min-w-0 text-[7px] text-white" data-node-id="2011:1534">
                {`Nền tảng thiết lập & đánh giá năng lực nhân viên TestCenter.vn`}
              </p>
            </div>
          </div>
        </div>

        {/* Divider + copyright */}
        <div className="flex flex-col gap-[8px] items-start w-full" data-node-id="2011:1535">
          <div className="h-0 relative w-full" data-node-id="2011:1536">
            <div className="absolute" style={{ inset: '-1px 0 0 0' }}>
              <img alt="" className="block max-w-none w-full h-full" src={imgLineMobile} />
            </div>
          </div>
          <p className="font-['Alexandria',sans-serif] font-light leading-[1.5] text-[12px] text-[#4d5965] text-center w-full" data-node-id="2011:1537">
            © 2014-2025 TopCV Vietnam JSC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}


// ──────────────────────────────────────────────
// Main export: switches between desktop / mobile
// using a CSS media query approach via Tailwind classes
// ──────────────────────────────────────────────
export default function Footer() {
  return (
    <div className="w-full bg-white" data-node-id="footer-root">
      {/* Desktop: show when viewport ≥ 840px */}
      <div className="hidden min-[840px]:block">
        <FooterDesktop />
      </div>
      {/* Mobile: show when viewport < 840px */}
      <div className="block min-[840px]:hidden">
        <FooterMobile />
      </div>
    </div>
  );
}
